/* eslint-disable @typescript-eslint/no-empty-function */
import { createContext, useContext } from "react";

interface ISeoContext{
    h1: string,
    setH1: (t: string) => void
}
export const SeoContext = createContext<ISeoContext>({
    h1: '',
    setH1: () => {},
})


export const useSeo = () => useContext(SeoContext)